import { render, staticRenderFns } from "./CourseEffectActions.vue?vue&type=template&id=2a9039df&scoped=true&"
import script from "./CourseEffectActions.vue?vue&type=script&lang=js&"
export * from "./CourseEffectActions.vue?vue&type=script&lang=js&"
import style0 from "./CourseEffectActions.vue?vue&type=style&index=0&id=2a9039df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9039df",
  null
  
)

export default component.exports